// extracted by css-extract-rspack-plugin
export default {"detail":"detail-lpbZB6"};